
    import '/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-guide-customize-style-demo-0","docs-guide-customize-style-demo-1"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/GPT-Vis/GPT-Vis/docs/guide/customize-style.md?type=demo')
};